<template>
  <div class="logo-with-text-wrapper">
    <div v-if="isFullMember && !$screenshotMode" class="ribbon">
      <span class="ribbon-msg"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            data-bs-custom-class="member-banner-tooltip"
            data-bs-offset="0,0"
            title="member">
        <img :src="`${$imagePathBase}logo-white.svg`"/>
      </span>
    </div>

    <svg viewBox="0 0 1818 1024" :height="height" class="logo-image">
      <g id="logo">
        <path id="text" class="logo-text" d="M1089.2,368.9v-155.2h-9.5l-57.2,124.2c-2.4,6.6-3.6,10-3.7,10.3l-1.2,3.5h-.6c-.8-2.3-1.6-4.4-2.3-6.3-.5-1.2-1-2.5-1.4-3.7-.3-1-.7-2-1.2-2.9l-58-125h-9.9v155.2h10.6v-112.8c0-6.9-.3-13.7-.8-20.7h.5c1.6,5.9,3.3,10.8,5.1,14.6l55.5,118.9h3.5l55.3-119.5c1.5-3.2,3.4-7.7,5.6-13.5h.4c-.8,12.6-1.2,20.2-1.2,22.8v110.2h10.5ZM1218.5,213.7h-11.6l-37.9,75c-2.5,4.8-4.3,8.6-5.3,11.3h-.4c-2-5.1-3.6-8.9-4.9-11.5l-36.2-74.8h-12l47.5,96.5v58.8h10.6v-59l50.2-96.2h0ZM1061.2,568.7c13.4-14.7,20.1-34.8,20.1-60.1s-6.6-42.2-19.7-56.6-30.4-21.7-51.8-21.7-41.6,7.4-55.1,22.3-20.3,34.8-20.3,59.8,6.6,42.1,19.9,56.6,30.9,21.8,52.9,21.8,40.5-7.4,53.9-22.1h0ZM1048,463.6c9.5,11.2,14.3,27,14.3,47.5s-4.9,35.6-14.7,46.7c-9.8,11.1-23.3,16.7-40.3,16.7s-28.9-5.8-38.8-17.5-14.9-27.1-14.9-46.2,5.1-34.6,15.3-46.4,23.4-17.7,39.7-17.7,29.9,5.6,39.4,16.8h0ZM1112.8,585.7c3.5,1.2,7.1,2.1,10.7,2.8,3.8.8,7.4,1.3,11,1.7,3,.4,6.1.6,9.1.6,7.1,0,14.1-.7,21-2.2,6.6-1.5,12.5-3.9,17.6-7.2,5-3.3,9.2-7.7,12.1-12.9,3-5.3,4.5-11.8,4.5-19.4s-1.1-10.9-3.3-15.4c-2.3-4.6-5.3-8.7-8.9-12.2-4-3.8-8.4-7.2-13.1-10.1-5-3-10.3-5.9-15.8-8.7-5.4-2.7-10.2-5.1-14.4-7.4-4.2-2.2-7.7-4.5-10.6-6.9s-5.1-5-6.6-7.9-2.2-6.3-2.2-10.3,1-7.9,2.9-10.8c1.9-3,4.5-5.4,7.6-7.3s6.6-3.2,10.6-4.1c3.9-.8,7.9-1.2,11.9-1.2,14.4,0,26.1,3.2,35.3,9.5v-20.5c-7-3.7-18.2-5.5-33.5-5.5s-13.3.8-19.8,2.5-12.2,4.2-17.3,7.6c-5,3.3-9.2,7.8-12.2,12.9-3.1,5.2-4.7,11.4-4.7,18.5s1,10.8,3,15.1c2,4.3,4.8,8.2,8.2,11.5,3.5,3.4,7.5,6.5,12.2,9.3s9.7,5.6,15.2,8.3c5.1,2.6,9.9,5.1,14.3,7.4,4.4,2.3,8.3,4.8,11.5,7.4,3.2,2.6,5.8,5.4,7.6,8.5,1.8,3.1,2.8,6.7,2.8,10.9,0,7.8-2.8,13.8-8.3,17.9-5.5,4.2-13.9,6.2-25.1,6.2s-7.1-.4-10.6-1c-3.9-.7-7.7-1.6-11.4-2.8-3.7-1.2-7.3-2.6-10.8-4.4-3.4-1.7-6.4-3.7-8.8-5.8v21.4c2,1.4,4.7,2.6,8.1,3.7h0l.2.3h0ZM1335.5,564.1c-11.4,6.9-24.9,10.4-40.5,10.4s-30.4-5.6-40.8-16.8-15.5-26.3-15.5-45.2,5.5-35.8,16.6-47.8c11.1-11.9,25.5-17.9,43.4-17.9s25.7,3.1,36.8,9.3v-19.4c-9.7-4.3-21.9-6.4-36.6-6.4-23,0-41.9,7.7-56.9,23-14.9,15.3-22.4,35.4-22.4,60.2s6.6,41.8,19.9,56,31,21.3,53.1,21.3,31.4-3,42.9-9.1v-17.7h0ZM1427.6,432.9h-18.8l-59.6,155.3h20.2l15.5-43.5h65.8l16.5,43.5h20.1l-59.8-155.3h.1ZM1391,528.3l24.1-66.2c.9-2.5,1.8-6,2.5-10.4h.4c.8,4.8,1.6,8.2,2.4,10.4l24.4,66.2h-53.8ZM1592.5,541.5c-2.1-3.4-4-6.4-5.7-8.9-1.6-2.4-3.3-4.7-5.1-6.9-1.6-1.9-3.5-3.7-5.5-5.3-2.1-1.6-4.4-2.9-6.8-4v-.4c5.3-1.4,10-3.3,14.2-5.8,4.1-2.4,7.8-5.4,10.8-9s5.4-7.7,6.9-12.1c1.6-4.5,2.4-9.5,2.4-14.9s-1.2-13-3.6-18.1-5.7-9.5-9.9-12.9c-4.2-3.5-9.2-6-14.9-7.7s-12-2.5-18.8-2.5h-46.4v155.3h18.2v-66.1h14.9c3.4,0,6.4.4,9.1,1.2s5.3,2.2,7.6,4c2.3,1.8,4.6,4.1,6.9,7,2.5,3.3,4.8,6.7,6.9,10.3l26,43.5h21.7l-29.1-46.7h.2ZM1553.4,449.4c10.2,0,18,2.3,23.3,7,5.4,4.7,8.1,11.1,8.1,19.4s-.8,8.8-2.4,12.5c-1.5,3.6-3.7,6.8-6.6,9.4s-6.3,4.6-10,5.9c-3.9,1.4-8.1,2.1-12.6,2.1h-24.7v-56.3h24.9,0ZM1017.3,807.5v-9.8h-62.5v-145.4h-10.6v155.2h73.1ZM1054.2,807.5v-155.2h-10.6v155.2h10.6ZM1103.2,807.7c7,1.7,13.1,2.5,18.4,2.5,15.1,0,26.7-3.8,35-11.3,8.2-7.5,12.4-17.2,12.4-29.1s-2.4-15.6-7.2-22c-4.8-6.4-14.5-13.7-29-21.9-14-8.1-23.1-14.5-27.3-19.2s-6.3-11-6.3-18.9,3.1-15,9.3-20.3c6.2-5.3,14.5-8,25.1-8s20,2.1,29.1,6.2v-11.3c-9.2-3.1-18.5-4.7-27.7-4.7-14.2,0-25.6,3.8-34.1,11.5s-12.8,17-12.8,27.9,2.1,15.2,6.3,21.4c4.2,6.2,14.1,13.8,29.8,23,14.1,8.2,23.2,14.6,27.4,19.3,4.2,4.7,6.3,11.1,6.3,19s-3.1,16.1-9.4,21.1-15.4,7.5-27.5,7.5-22.6-3.5-33.7-10.6v12.2c3.7,2.2,9,4.1,15.9,5.7h0ZM1287.1,662.1v-9.8h-100.3v9.8h44.8v145.4h10.6v-145.4h44.9Z"/>
        <rect id="border" class="logo-border" x="45.9" y="50.4" width="1726.5" height="921.8"/>
        <g id="logo1" class="logo-art">
          <g id="laurel">
            <g>
              <path d="M420.5,247c-10.8,21.5-24.3,42.8-39.4,61.4-12.8,15.9-32.8,37.9-48.6,50.7-.5.5-2.6,2-3.1,1.8-6.4-15.9-7.4-33.5-2.8-50.2,11-38.9,55-64,94-63.8h-.1Z"/>
              <path d="M693.2,341.2c-.5.5-8.2-4.4-9.5-5.1-36.4-23-67.8-47.4-92.2-83.5-.8-1-5.4-7.4-4.6-8.2,34.6-2.8,72.7,9,93.4,37.9,12,16.6,16.9,38.7,12.8,58.9h0Z"/>
            </g>
            <g>
              <g>
                <path d="M759,463.6c-3.6-11.3-6.4-23-7.9-34.8-4.1-32,1.3-68.1,8.7-99.3.3-1.5,1.5-8.4,3.1-8.2,24.6,25.1,39.7,61.7,29.4,96.5-3.8,12.8-12,26.1-21.3,35.8-1.3,1.3-10.8,10.2-11.8,9.7l-.3.3h0Z"/>
                <path d="M749.8,493.5c-1,1-23.6-9.5-26.4-10.8-17.9-9-35.8-21-47.4-37.6-4.4-6.4-9-13.8-10.8-21.5,21-4.4,42.8-2.6,59.9,11.3,13.1,10.5,21.5,27.9,23.8,44.3.3,2,1.5,13.6.5,14.3h.4Z"/>
              </g>
              <g>
                <g>
                  <path d="M826.3,485.3c4.6,21.8,3.3,44.5-4.6,65.3-10.5,27.7-34.1,46.3-62.7,53-1.3-1.5,4.4-26.4,5.1-30,8.7-34.1,23.6-56.8,49.9-79.6,2.3-2,8.2-7.4,10.8-8.7s1-.3,1.5-.3v.3h0Z"/>
                  <path d="M689.1,523.7c22,8.2,48.1,25.9,54.8,49.7,4.9,17.2,2.3,37.4-7.2,52.5-12-13.8-24.8-28.4-34.3-44-10.8-17.9-16.4-37.1-13.6-58.1h.3Z"/>
                </g>
                <g>
                  <path d="M808.2,653.8c-8.4,32.3-33,63.2-66.1,72.2-18.9,5.1-38.1,3.3-56.3-3.3-.5-.5,2-3.3,2.6-3.8,6.1-7.2,15.6-15.9,23-22,27.7-23,61.7-35.8,96.8-43h0Z"/>
                  <path d="M654.8,728.8c-4.4-36.6-9.7-78.1,15.9-108.3,14.8,15.4,25.1,37.9,22,59.4-2.8,20.7-18.9,40.5-37.9,48.9h0Z"/>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path d="M259.3,353.2c8.2,16.6,15.4,35.1,20.2,53,6.7,24.3,8.2,47.6,4.1,72.5,0,1.5-2.3,13.1-3.1,13.1-21.3-14.1-38.4-36.1-42.2-62-4.1-26.6,4.9-55.3,21-76.6Z"/>
                  <path d="M388,410.1c.8.8-4.4,8.2-5.1,9.2-14.8,19.7-39.7,31.7-62.5,40.2-2.6,1-21.5,7.7-22.3,6.7,1.8-28.4,18.2-56.6,47.9-62,14.8-2.8,28.4.3,42,5.9h0Z"/>
                </g>
                <g>
                  <path d="M294.6,630.5c-34.6-2.8-63.8-25.3-74.5-58.4-5.6-17.4-6.9-37.1-3.8-55,.8-.5,10,6.1,11.3,7.2,24.1,17.7,42.5,41,54.5,68.4,5.4,12,10,24.8,12.5,37.9h0Z"/>
                  <path d="M356.8,500.4c.3,11.5-1,23.3-4.4,34.3-2.8,9.5-7.2,16.6-13.1,24.3-11.3,15.1-26.1,28.4-40.5,40.5-1,0-3.8-10.2-4.1-12-7.4-36.1,11.8-65.3,43.5-80.6,2.3-1,17.4-7.7,18.4-6.4h.2Z"/>
                </g>
              </g>
              <g>
                <path d="M251.6,686.3c19.2,1.5,38.7,4.9,57.1,10.5,22.3,6.9,42.5,18.2,60.7,32.3,1.8,1.3,12,9.2,11.8,10.5-23,12.8-52.2,14.8-76.3,4.1-17.9-7.9-35.1-24.6-45.3-41.2-1-1.8-8.7-15.4-7.9-16.1h-.1Z"/>
                <path d="M365.8,602.8c21.3,33.3,11,73,2.6,108.8-1.3,1.3-12.8-10-14.1-11.3-24.1-26.4-22.5-61.4.8-87.8,1.8-1.8,7.4-7.9,9-9.2.5-.3,1-.8,1.8-.5h0Z"/>
              </g>
            </g>
          </g>
          <g>
            <path id="check" d="M576.7,636.4c5.6,4.9,10.8,12.3,16.4,17.4,1.5,2.6,1.5,6.9,0,9.5-24.8,26.9-49.9,53.3-75.5,79.4-3.1,3.1-11.5,13.6-14.6,14.8-2.3,1-4.1,1-6.4.3-18.7-17.7-35.6-37.6-53.8-55.8-3.1-3.3-4.1-7.4-1.3-11.5,2-3.1,13.6-15.4,16.4-17.4,3.3-2.6,6.4-2.8,10-.3l32,33.5,67.3-70.9c3.1-2.3,6.9-1.8,9.7.8l-.3.3h0Z"/>
            <path id="box" d="M436.7,572.1h159.8c18.7,1,34.1,14.6,37.1,33,1,55.8,1,111.9,0,167.7-2.8,16.1-15.6,28.9-31.7,32-56.6,1-113.7,1.3-170.3,0-17.4-3.6-30.5-18.2-31.7-35.8v-161c2-19.7,17.2-34.3,36.9-36.1v.3h0ZM420.5,593.4c-3.8,3.8-6.9,10.2-7.2,15.6.5,54.5-.8,109.1.8,163.3,2.8,10.8,11.8,18.4,22.8,19.7h159.5c13.1-1.3,23-11.5,24.1-24.6v-157.5c-1-11.5-9-21-20.2-23.8-55.6-1-111.6-1.3-167.2,0-4.4,1-9.5,3.8-12.5,6.9v.3h0Z"/>
          </g>
          <path id="statuette" d="M467.1,554.7c-.8-24.1,1.3-47.9,7.7-70.9,0-.5-6.4-2-7.9-2.8-16.9-7.2-18.2-24.3-22.3-40.5-5.1-21.8-15.6-66.6-6.1-86.8,11.5-24.3,55-16.6,57.1-46.6.5-7.9-2.8-9.5-5.1-16.1-3.3-9.7-5.4-32.8-2-42.2,9-27.7,51.7-26.1,58.1,2.6,2.3,10.2.3,30.7-3.3,40.7-1,2.6-4.4,7.9-4.6,9.5-4.6,33,40.7,28.2,54.5,48.1,13.3,19.2,1.5,67.6-3.6,89.6-2,8.2-6.1,28.4-11.5,34.1-4.6,5.1-12.5,8.4-19.2,10,6.4,23,9.2,47.6,7.7,71.4h-99.5Z"/>
        </g>
      </g>
      <!--
          <g v-if="isFullMember && !$screenshotMode" id="member-ribbon">
            <polygon class="member-ribbon" points="591 0 0 591 0 377.4 377.4 0 591 0"/>
            <g class="member-ribbon-text">
              <path d="M176.1,362.8l-12.6,12.6-33.8-33.8c-1.4-1.4-2.8-2.9-4.2-4.3-1.4-1.4-2.9-3-4.6-4.8l-.3.3c.6,1.2,1.1,2.2,1.6,3.1.5.9.9,1.8,1.3,2.7l25.2,51.6-10.4,10.4-51.4-24.5c-1-.5-1.9-1-2.7-1.4-.8-.4-1.9-1.1-3.5-1.9l-.4.4c2.4,2.2,4.5,4.2,6.3,6,1.8,1.8,3.6,3.5,5.4,5.3l31.2,31.2-11.7,11.7-56.4-56.4,18.8-18.8,45,21.9c1.6.8,3,1.5,4.2,2.1,1.2.6,2.6,1.4,4.3,2.4l.2-.2c-.9-1.9-1.7-3.4-2.2-4.5-.5-1.1-1.2-2.5-2.1-4.3l-21.8-44.9,18.1-18.1,56.4,56.4Z"/>
              <path d="M221.9,316.9l-33.9,33.9-56.4-56.4,32.6-32.6,10.5,10.5-19.8,19.8,12.3,12.3,18.5-18.5,10.5,10.5-18.5,18.5,12.6,12.6,21.1-21.1,10.5,10.5Z"/>
              <path d="M294.7,244.2l-12.6,12.6-33.8-33.8c-1.4-1.4-2.8-2.9-4.2-4.3-1.4-1.4-2.9-3-4.6-4.8l-.3.3c.6,1.2,1.1,2.2,1.6,3.1.5.9.9,1.8,1.3,2.7l25.2,51.6-10.4,10.4-51.4-24.5c-1-.5-1.9-1-2.7-1.4-.8-.4-1.9-1.1-3.5-1.9l-.4.4c2.4,2.2,4.5,4.2,6.3,6,1.8,1.8,3.6,3.5,5.4,5.3l31.2,31.2-11.7,11.7-56.4-56.4,18.8-18.8,45,21.9c1.6.8,3,1.5,4.2,2.1,1.2.6,2.6,1.4,4.3,2.4l.2-.2c-.9-1.9-1.7-3.4-2.2-4.5-.5-1.1-1.2-2.5-2.1-4.3l-21.8-44.9,18.1-18.1,56.4,56.4Z"/>
              <path d="M306.8,232.1l-56.4-56.4,20.9-20.9c6.3-6.3,12.4-9.9,18.3-10.8,5.9-.9,11.1,1,15.7,5.6,2.8,2.8,4.4,6.2,4.8,10.1.4,3.9-.4,7.6-2.2,11.2l.2.2c3.9-2.9,8.1-4.2,12.6-3.9,4.4.4,8.4,2.3,11.8,5.7,5.2,5.2,7.4,11.1,6.8,17.9-.7,6.7-4.2,13.3-10.6,19.7l-21.7,21.7ZM272.7,172.6l13.4,13.4,5.9-5.9c2.6-2.6,4.1-5.3,4.3-8,.3-2.7-.8-5.3-3.1-7.7-2-2-4.2-2.9-6.6-2.6-2.4.2-4.9,1.7-7.5,4.3l-6.5,6.5ZM295.6,195.5l14.2,14.2,6.9-6.9c2.9-2.9,4.6-5.9,4.9-8.9.4-3-.6-5.6-2.9-7.9-2.1-2.1-4.6-3-7.5-2.6-2.9.4-5.8,2.1-8.7,5l-7,7Z"/>
              <path d="M391.5,147.4l-33.9,33.9-56.4-56.4,32.6-32.6,10.5,10.5-19.8,19.8,12.3,12.3,18.5-18.5,10.5,10.5-18.5,18.5,12.6,12.6,21.1-21.1,10.5,10.5Z"/>
              <path d="M445.6,93.3l-14.3,14.3-23.7-6.9c-3.2-.9-5.8-1.3-7.7-1.2-1.9.2-3.6,1-5.1,2.5l-3.4,3.4,21,21-12.7,12.7-56.4-56.4,20.2-20.2c7-7,13.6-10.7,19.9-11.2,6.3-.4,11.8,1.8,16.7,6.6,3.5,3.5,5.7,7.8,6.5,12.8.8,5-.1,9.9-2.8,14.8l.2.2c2-.9,4.3-1.3,6.9-1.2,2.6,0,5.8.7,9.6,1.7l25.2,7ZM365.7,79.6l16,16,5.5-5.5c2.9-2.9,4.4-5.9,4.4-9,0-3.1-1.2-5.9-3.8-8.5-2.4-2.4-5.1-3.6-7.8-3.4-2.8.2-5.7,1.7-8.6,4.7l-5.7,5.7Z"/>
            </g>
          </g>
      -->
    </svg>
  </div>


</template>


<script>

import {userStore} from "@/userStore";

export default {
  name: "LogoWithText",
  props: ['height'],
  computed: {
    isFullMember() {
      return userStore.isFullMember();
    },
  }
}

</script>


<style>
.member-banner-tooltip {
  /* OVERRIDABLE BOOTSTRAP VARIABLES
  --bs-tooltip-zindex
  --bs-tooltip-max-width
  --bs-tooltip-padding-x
  --bs-tooltip-padding-y
  --bs-tooltip-margin
  --bs-tooltip-color
  --bs-tooltip-bg
  --bs-tooltip-border-radius
  --bs-tooltip-opacity
  --bs-tooltip-arrow-width
  --bs-tooltip-arrow-height
   */

  /*--bs-tooltip-bg: var(--mol-color-red-carpet-slightly-faded)!important;*/
  /*--bs-tooltip-bg: #b49823!important;*/
  --bs-tooltip-bg: #910707 !important;
  --bs-tooltip-color: white!important;

  --bs-tooltip-opacity: 1.0!important;
  --bs-tooltip-arrow-height: 10px!important;
  --bs-tooltip-arrow-width: 10px!important;
  font-size: x-small!important;
}
</style>


<style scoped>


.logo-with-text-wrapper {
  position: relative;
}

.logo-border {
  fill: none;
  stroke: var(--bs-body-color);
  stroke-miterlimit: 10;
  stroke-width: 12.8px;
}


.logo-text {
  fill: var(--bs-body-color);
}

.logo-art {
  fill: var(--bs-body-color);
}

.member-ribbon {
  fill: #c40404;
}

.member-ribbon-text {
  fill: #fff;
}


.ribbon-msg {
  height: 12px;
  img {
    display: block;
    margin: 2px auto 2px auto;
    height: 8px;
    pointer-events: none;
  }
}

.ribbon {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
  /*background-color: lightcyan;*/
}
.ribbon span {
  font-size: 10px;
  font-weight: 500;
  color: white;
  /*text-transform: uppercase;*/
  text-align: center;
  line-height: 12px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  width: 40px;
  display: block;
  background: var(--mol-color-red-carpet-background);
  background: linear-gradient(var(--mol-color-red-carpet-slightly-faded) 0%, var(--mol-color-red-carpet) 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 4.5px;
  left: -9.8px;
}
.ribbon span::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left:1px solid var(--mol-color-red-carpet);
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid var(--mol-color-red-carpet);
}
.ribbon span::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 1px solid transparent;
  border-right: 1px solid var(--mol-color-red-carpet);
  border-bottom: 1px solid transparent;
  border-top: 1px solid var(--mol-color-red-carpet);
}

</style>